import accountsJwtService, { jwtManager } from 'app/services/jwtService';

export const hasResumableSession = () =>
  jwtManager.getIsTokenValid(jwtManager.getAccessToken()) ||
  jwtManager.getIsTokenValid(jwtManager.getRefreshToken());

export const accessTokenFactory = async () => {
  const accessToken = jwtManager.getAccessToken();

  if (jwtManager.getIsTokenValid(accessToken)) {
    return accessToken.value;
  }

  if (jwtManager.getIsTokenValid(jwtManager.getRefreshToken())) {
    try {
      await accountsJwtService.handleRefresh({});
    } catch {
      return null;
    }

    return jwtManager.getAccessTokenValue() ?? null;
  }

  return null;
};
